var upperCase = require('upper-case')
var snakeCase = require('snake-case')

/**
 * Constant case a string.
 *
 * @param  {String} string
 * @param  {String} [locale]
 * @return {String}
 */
module.exports = function (string, locale) {
  return upperCase(snakeCase(string, locale), locale)
}



//////////////////
// WEBPACK FOOTER
// ./~/constant-case/constant-case.js
// module id = 1055
// module chunks = 4